<template>

  <div class="relative p-4">
    <div class="flex items-center">
      <img class="w-14 rounded-lg shadow-lg" src="../../assets/img/placeholder_avatar.png" alt="">
      <div class="mr-4">
        <h3>{{ this.$store.state.user.name }}</h3>
      </div>
    </div>

    <hr class="border-ColorNerkh/50 my-4">

    <ProfileCard title="ویرایش اطلاعات" to="/profile/edit">
      <font-awesome-icon icon="user"  class="text-ColorNerkh w-6 h-6"/>
    </ProfileCard>

    <ProfileCard title="لیست سفارشات" to="/profile/factors">
      <font-awesome-icon icon="rectangle-list" />
    </ProfileCard>
    <div class="flex items-center p-2 rounded-lg mt-4" @click="logout()"
         @touchstart="toggleAnimation" @touchend="toggleAnimation">
      <div class="bg-red-500/20 rounded-lg p-1 shadow">
        <LogoutIcon class="text-red-500 w-6 h-6"/>
      </div>
      <span class="mr-4 text-red-500">خروج</span>
      <ChevronLeftIcon class="text-red-500 w-5 h-5 mr-auto"/>
    </div>

    <div class="flex justify-center items-center w-full h-20 bg-brand/20 text-brand rounded-lg mt-8">
      <SupportIcon class="h8 w-8 ml-2"/>
      تماس با پشتیبانی
    </div>

  </div>
</template>

<script>
import ProfileCard from "@/components/User/ProfileCard";

export default {
  name: "ProfilePage",
  components: {ProfileCard},
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-red-500/20')
    },
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>

</style>